import Vue from 'vue'
import Vuex from 'vuex'
import {getRoom, setRoom} from "@/utils/roomCookie";
import {getSilentMode,setSilentMode} from "@/utils/cookieUtil";

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        groupForm: {
            Huodongmingcheng: "",
            Canjiaren: "",
            Lianxidianhua: "",
            Lianxiren: "",
            Lianxidanweituandui: "",
            date: "",
            StartTime: "",
            EndTime: ""
        },
        nowRoom: getRoom(),
        routerViewShow: true,


        silentMode:getSilentMode()
    },
    mutations: {
        setGroupForm(state, group) {
            state.groupForm = group
        },
        setNowRoom(state, room) {
            state.nowRoom = room
            setRoom(room)
        },
        setRouterViewShow(state, show) {
            state.routerViewShow = show
        },
        setSilentMode(state,silent){
            state.silentMode = silent
            setSilentMode(silent)
        }
    },
    actions: {},
    modules: {}
})
